import api from '@/services/api-recebimentoweb';

export default {
  namespaced: true,

  state: {
    list: [],
    atendimento: {},
  },

  getters: {
    list: (state) => state.list,
    atendimento: (state) => state.atendimento,
  },

  actions: {
    async find(_, { where, ...params } = {}) {
      const { data } = await api.get('atendimento', { params: { ...where, ...params } });
      return data;
    },

    async findById(_, id) {
      const { data } = await api.get(`atendimento/${id}`);
      return data;
    },

    async create(_, body) {
      const { data } = await api.post('atendimento', body);
      return data;
    },

    async update({ commit }, body) {
      const { data } = await api.put(`atendimento/${body.id}`, body);
      commit('SET_ATENDIMENTO', data);
      return data;
    },

    async delete(_, body) {
      const { data } = await api.delete(`atendimento/${body.id}`);
      return data;
    },

    async searchClientes(_, { nome }) {
      const { data } = await api.get('atendimento/search/geral-clientes', { params: { nome } });
      return data;
    },
  },

  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
    SET_ATENDIMENTO(state, atendimento) {
      state.atendimento = atendimento ?? {};
    },
    CLEAR_ATENDIMENTO(state) {
      state.atendimento = {};
    },
  },
};
